export default __webpack_public_path__ + "static/char-30-3761fa32633d67df215bf2f157af2404.webp";